import instance from './Request';

export const getAreas = async () => {
  const request = await instance();
  let data = await request
    .get('/areas')
    .catch((error) => {
      return {
        error,
      };
    });
  return data;
};

export const getArea = async id => {
    const request = await instance();
    let data = await request
      .get(`/areas/${id}`)
      .catch((error) => {
        return {
          error,
        };
      });
    return data;
  };

export const newArea = async area => {
  const request = await instance();
  let data = await request
    .post('/areas', area)
    .catch((error) => {
      return {
        error,
      };
    });
  return data;
};

export const editArea = async area => {
  const request = await instance();
  let data = await request
    .post(`/areas/${area.id}`, area)
    .catch((error) => {
      return {
        error,
      };
    });
  return data;
};

export const delArea = async id => {
  const request = await instance();
  let data = await request
    .delete(`/areas/${id}`)
    .catch((error) => {
      return {
        error,
      };
    });
  return data;
};

export const toggleArea = async (area) => {
  const request = await instance()
  const response = await request.post(`/areas/${area.id}/toggle`, area).catch((error)=>{
    return {
      error
    }
  })
  return response
}

